/**
 *
 * Split a camel case string to Captialalise
 * @param {string} word
 *
 * @input -> 'xiftIsPowerful
 * @output -> Xift Is Powerful
 */

export function splitCamelCase(word) {
  // check for falsy values
  if (!word) {
    return '';
  }
  const result = word.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
  return result[0].toUpperCase() + result.substring(1);
}
/**
 * Split a underscore case string to Captialalise
 * @param {string} word
 *
 * @input -> 'xift_is_powerful
 * @output -> xift Is Powerful
 */
export function splitUnderscoreToCaptialise(word) {
  // check for falsy values
  if (!word) {
    return '';
  }
  return word.replace(/(^|_)(\w)/g, function($0, $1, $2) {
    return ($1 && ' ') + $2.toUpperCase();
  });
}
/**
 * check wether a variable passed is object
 * @param {*} variable
 */
export function isObject(variable) {
  return Object.prototype.toString.call(variable) === '[object Object]';
}

/**
 * check wether a variable passed is array of strings
 * @param {*} variable
 */
export function isStringArray(variable) {
  const status = Object.prototype.toString.call(variable) === '[object Array]';
  if (status) {
    return typeof variable[0] === 'string';
  }
  return false;
}

/**
 * check wether a variable passed is array of objects
 * @param {*} variable
 */
export function isObjectArray(variable) {
  return Object.prototype.toString.call(variable) === '[object Array]';
}

/**
 * check wether a variable passed is
 * @param {*} x
 */
export function isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}

/**
 * Turns object to array with key as id and other value
 * @param {Object} obj
 */
export function objectsForEach(obj, type) {
  let tempArr = [];
  if (typeof obj !== 'object') {
    return tempArr;
  }
  for (const [key, value] of Object.entries(obj)) {
    if (type === 'STRING_VAL') {
      tempArr.push({ id: key, value });
    } else {
      tempArr.push({ id: key, ...value });
    }
  }
  return tempArr;
}

/**
 * convert a string to snake case
 * @param {String} variable
 */
export function toSnakeCase(variable) {
  return String(variable)
    .toUpperCase()
    .replace(' ', '_');
}
/**
 * Convert any string to kebab-case
 *
 * @param {String} str , any string value
 * @returns kebab-case-string string
 *
 * @input -> All is well
 * @output -> all-is-well
 */
export function toKebabCase(str) {
  return String(str)
    .toLowerCase()
    .split(' ')
    .join('-');
}
/**
 * Merge two array based on Id
 * Compare wether value of before is same as value of after
 * @param {*} array1
 * @param {*} array2
 * @param {*} key
 */
export function mergeTwoArrayByKey(array1, array2, key) {
  return array1.data.map(arrayItem1 => ({
    id: arrayItem1.id,
    title: arrayItem1.title,
    isChanged:
      JSON.stringify(
        array2.data.find(
          arrayItem2 => arrayItem2[key] === arrayItem1[key] && arrayItem2
        )?.val
      ) === JSON.stringify(arrayItem1?.val)
        ? false
        : true,
    [array2.key]: array2.data.find(
      arrayItem2 => arrayItem2[key] === arrayItem1[key] && arrayItem2
    )?.val,
    [array1.key]: arrayItem1?.val
  }));
}

/**
 *
 * @param {*} variable
 */
export function removeHTMLTags(variable) {
  const regex = /(<\/?)([a-zA-Z]{0,20}|[a-zA-Z]{0,20} .*?)(\/?>)/gi;
  return String(variable).replace(regex, '');
}

/**
 * This function helps to convert number into standard format
 * @param {Number} number
 */
export function numberINString(number, type, params) {
  return Number(number).toLocaleString(type, params);
}

/**
 * This function convert object to query params
 * @param {Object} queryObject
 */
export function objectToQueryParams(queryObject) {
  return Object.entries(queryObject)
    .map(([key, val]) => `${key}=${val}`)
    .join('&');
}

/**
 * It takes a array of strings and returns the object
 * @param {Array<String>} array
 */
export function uniqueCountForStrings(array) {
  let count = {};

  array.forEach(function(i) {
    count[i] = (count[i] || 0) + 1;
  });
  return count;
}

/**
 *
 * @param {Object<any>} obj1
 * @param {Object<any>} obj2
 */
export function objectCompare(obj1, obj2) {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}

/**
 *
 * @param {Object<any>} object
 * @param {*} value
 */
export function getKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] === value);
}

/**
 * Check for empty object
 *
 * @param {Object<any>} object
 */
export function isEmptyObject(object) {
  if (object) {
    return Object.keys(object).length === 0;
  }
}

/**
 * Filter object by keys
 *
 * @param {Object<any>} object
 * @param {Array} keys array of keys
 * @param {Boolean} isAllowed array of keys is allowed or not
 */
export function filterObjectByKeys(object, keys, isAllowed) {
  if (object) {
    return Object.keys(object)
      .filter(key => (isAllowed ? keys.includes(key) : !keys.includes(key)))
      .reduce((filteredObj, key) => {
        filteredObj[key] = object[key];
        return filteredObj;
      }, {});
  }

  return {};
}

/**
 * To convert blob data to JSON
 * @param {Blob} blobData , blob data
 */
export function convertBlobToJSON(blobData) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function() {
      try {
        const jsonData = JSON.parse(reader.result);
        // Now, jsonData contains the parsed JSON data
        resolve(jsonData);
      } catch (error) {
        reject(error);
      }
    };
    reader.readAsText(blobData);
  });
}
